<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Daftar : Pelanggan">
            <!-- <div class="message-box">
                <w-transition-fade>
                    <w-alert
                        class="my0 text-light"
                        v-if="form.submitted"
                        success
                        no-border
                    >
                        The form is valid, ready to send it!
                    </w-alert>

                    <w-alert
                        class="my0 text-light"
                        v-else-if="form.valid === false"
                        error
                        no-border
                    >
                        Terdapat {{ form.errorsCount }} ralat di dalam borang
                        ini.
                    </w-alert>
                </w-transition-fade>
            </div> -->

            <w-form
                class=""
                v-model="form.valid"
                v-model:errors-count="form.errorsCount"
                @validate="submitProfil"
                @success="onSuccess"
            >
                <w-flex justify-right align-right class="mt3">
                    <div class="xs6 mr3">
                        <z-lookup
                            label="Kategori Profil *"
                            :options="kategori"
                            v-model="form_profil.kategori"
                            placeholder="Sila Pilih Kategori Profil"
                            :sort="false"
                            :cache="false"
                            :validators="[validators.required]"
                        /><br />
                    </div>

                    <div class="xs6 mr3">
                        <z-lookup
                            label="Jenis Pengenalan Diri *"
                            name="lkp_pengenalan_id"
                            placeholder="Sila Pilih Jenis Pengenalan Diri"
                            :url="service_kutipan + 'lookup/pengenalan'"
                            :sort="false"
                            :cache="false"
                            v-model="form_profil.lkp_pengenalan_id"
                            :validators="[validators.required]"
                        /><br />
                    </div>
                </w-flex>

                <w-flex justify-right align-right class="mt3">
                    <div class="xs6 mr3">
                        <z-input
                            label="No. ID ( No Kad Pengenalan / No Tentera / No Daftar Syarikat )*"
                            placeholder="Sila Masukkan No. ID"
                            v-model="form_profil.no_id"
                            :validators="[validators.required]"
                        />
                    </div>
                    <div class="xs6">
                        <z-input
                            label="Nama *"
                            v-model="form_profil.nama"
                            placeholder="Sila Masukkan Nama"
                            :validators="[validators.required]"
                        />
                    </div>
                </w-flex>

                <!-- <w-flex justify-right align-right class="mt7">
                    <div class="xs2">
                        <td class="fw-semibold m0" style="font-size: 11px">
                            Jenis Alamat *
                        </td>
                    </div>

                    <template v-for="(dt, index) in lkp_jenis_alamat">
                        <w-radio
                            class="mr4"
                            v-model="form_profil.lkp_jenis_alamat_id"
                            :return-value="dt.value"
                        >
                            {{ dt.label }}
                        </w-radio>
                    </template>
                </w-flex> -->

                <div class="xs10">
                    <w-flex justify-center align-center class="mt7">
                        <z-input
                            label="Alamat Surat Menyurat *"
                            v-model="form_profil.alamat1"
                            placeholder="Sila Masukkan Alamat Surat Menyurat"
                            :validators="[validators.required]"
                        />
                    </w-flex>

                    <w-flex justify-center align-center class="mt7">
                        <z-input
                            v-model="form_profil.alamat2"
                            placeholder="Sila Masukkan Alamat Surat Menyurat"
                        />
                    </w-flex>

                    <w-flex justify-center align-center class="mt7">
                        <z-input
                            v-model="form_profil.alamat3"
                            placeholder="Sila Masukkan Alamat Surat Menyurat"
                        />
                    </w-flex>
                </div>

                <w-flex justify-left align-left class="mt5">
                    <div class="xs4 mr3">
                        <z-lookup
                            label="Poskod *"
                            name="poskod"
                            placeholder="Sila Pilih Poskod"
                            :url="service_kutipan + 'lookup/lkp_poskod'"
                            :sort="false"
                            :cache="false"
                            v-model="form_profil.lkp_poskod_id"
                            :validators="[validators.required]"
                        /><br />
                    </div>

                    <div class="xs4 mr3">
                        <td class="fw-semibold m0" style="font-size: 11px">
                            Bandar &nbsp;&nbsp;&nbsp;
                        </td>
                        <tr>
                            {{
                                form_profil.bandar
                            }}
                        </tr>
                    </div>
                    <div class="xs4">
                        <td class="fw-semibold m0" style="font-size: 11px">
                            Negeri &nbsp;&nbsp;&nbsp;
                        </td>
                        <tr>
                            {{
                                form_profil.negeri
                            }}
                        </tr>
                    </div>
                </w-flex>
                <w-flex justify-center align-center class="mt4">
                    <div class="xs6 mr3">
                        <z-input
                            label="No. Telefon *"
                            v-model="form_profil.no_tel"
                            placeholder="Sila Masukkan No. Telefon"
                            name="no_tel"
                            type="tel"

                        />
                    </div>
                    <div class="xs6">
                        <z-input
                            label="Emel *"
                            type="email"
                            v-model="form_profil.emel"
                            placeholder="Sila Masukkan Emel"

                        />
                    </div>
                </w-flex>

                <w-flex class="mt4" wrap align-center justify-end>
                    <div class="spacer" />
                    <w-button
                        class="mr2"
                        bg-color="warning"
                        type="reset"
                        @click="form.submitted = form.sent = false"
                    >
                        Reset
                    </w-button>

                    <template v-if="$zutil.can('Pelanggan Daftar')">
                        <w-button
                            class="my1"
                            type="submit"
                            :disabled="form.valid === false"
                            :loading="form.submitted && !form.sent"
                        >
                            <w-icon dark tile class="mr2">fal fa-save</w-icon>
                            Hantar
                        </w-button>
                    </template>
                </w-flex>
            </w-form>

            <w-notification
                v-model="form.sent"
                success
                transition="bounce"
                absolute
                plain
                round
                bottom
            >
                Borang telah berjaya dihantar
            </w-notification>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";
// import moment from 'moment'

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        id: [Array, Object, String],
    },
    data() {
        return {
            resourceurl: this.service_kutipan + "profil",
            reload: true,
            dialog: {
                show: false,
                show2: false,
                fullscreen: false,
                persistent: false,
                persistentNoAnimation: false,
                width: 500,
            },
            form: {
                valid: null,
                submitted: false,
                sent: false,
                errorsCount: 0,
                no_tel: "",
            },
            validators: {
                required: (value) => !!value || "Medan Ini Wajib Isi",
                consent: (value) => !!value || "You must agree",
                email: (value) =>
                    !!value.match(/\w+\.?\w+@\w+(\.\w+)+/i) ||
                    "Sila Semak Format Email",
                numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
            },
            form_profil: {},
            form_cari: {},
            // lkp_jenis_alamat: [],
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan" },
                { label: "Pelanggan", route: "/pelanggan" },
                { label: "Daftar", route: "/kutipan/pelanggan/daftar" },
            ],

            kategori: [
                {
                    value: 1,
                    label: "INDIVIDU",
                },
                {
                    value: 2,
                    label: "SYARIKAT",
                },
            ],
        };
    },
    methods: {
        onSuccess() {
            setTimeout(() => (this.form.sent = true), 2000);
            this.$inertia.visit(window.route("kutipan.pelanggan.index"));
        },
        onValidate() {
            this.form.sent = false;
            this.form.submitted = this.form.errorsCount === 0;
        },
        poskodDetail() {
            this.$zcomm
                .get(
                    this.service_kutipan +
                        "lookup/lkp_poskod_detail/" +
                        this.form_profil.lkp_poskod_id
                )
                .then((res) => {
                    this.form_profil.negeri = res.negeri;
                    this.form_profil.lkp_negeri_id = res.lkp_negeri_id;
                    this.form_profil.bandar = res.bandar;
                    this.form_profil.lkp_jenis_alamat_id = 1;
                    // this.form_profil.lkp_jenis_alamat_id = res.lkp_jenis_alamat_id;
                });
        },
        profilDetail() {
            this.$zcomm
                .get(this.service_kutipan + "profil/" + this.form_cari.id)
                .then((res) => {
                    this.form.profil_id = res.id;
                    this.form.kategori = res.kategori;
                    this.form.lkp_pengenalan_id = res.lkp_pengenalan_id;
                    this.form.no_id = res.no_id;
                    this.form.nama = res.nama;
                    this.form.alamat1 = res.alamat1;
                    this.form.alamat2 = res.alamat2;
                    this.form.alamat3 = res.alamat3;
                    this.form.poskod = res.poskod;
                    this.form.bandar = res.bandar;
                    this.form.negeri = res.negeri;
                });
        },
        // jenisAlamat() {
        //     this.$zcomm
        //         .get(this.service_kutipan + "lookup/jenis_alamat")
        //         .then((res) => {
        //             this.lkp_jenis_alamat = res;
        //         })
        //         .catch((err) => {})
        //         .finally(() => {});
        // },
        submitProfil() {
            // if (this.$refs.form.validate()) {
            this.dialog.loading = true;

            this.$zcomm
                .post(this.service_kutipan + "profil", this.form_profil)
                .then((res) => {
                    // console.log(res)
                    //update displayed record
                    // this.$page.flash.success = "Rekod telah ditambah"
                    this.mapreturneddata(res);
                    this.dialog.show = false;
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                    this.form.profil_id = res.id;
                    this.form.kategori = res.kategori;
                    this.form.lkp_pengenalan_id = res.lkp_pengenalan_id;
                    this.form.no_id = res.no_id;
                    this.form.nama = res.nama;
                    this.form.lkp_jenis_alamat = res.lkp_jenis_alamat;
                    this.form.alamat1 = res.alamat1;
                    this.form.alamat2 = res.alamat2;
                    this.form.alamat3 = res.alamat3;
                    this.form.poskod = res.poskod;
                    this.form.bandar = res.bandar;
                    this.form.negeri = res.negeri;
                    // this.$inertia.visit(this.$page.url)
                })
                .finally(() => {
                    this.dialog.loading = false;

                    // $('#' + this.resourceurl).modal('hide')
                });

            // }
        },
    },
    watch: {
        "form_profil.lkp_poskod_id": function (q) {
            this.poskodDetail();
        },
        "form_cari.id": function (q) {
            this.profilDetail();
        },
    },
    mounted() {
        this.dialog.width = 900;
        //  this.jenisAlamat();
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
